import React from 'react'
import { ApiHook } from '../../hooks/apiHook'
import { useTranslation } from 'react-i18next'
import { ListGroup, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux'
import CurrencyConverter from '../../Currency/CurrencyConverter';
import { toast } from 'react-toastify'
import { Rowing } from '@mui/icons-material';

function RefundRequest() {
    const getRefundDetails = ApiHook.CallTFFrefundDetails()
    const refundRequest = ApiHook.CallrefundRequest()
    const currency = useSelector(
        (state) => state.user?.selectedCurrency
    );
    const conversionFactor = useSelector(
        (state) => state?.user?.conversionFactor
    );
    const { t } = useTranslation()
    const refundRequestHandler = async () => {
        const payload = {
            type: 'tff',
            tffPurchaseId: getRefundDetails?.data?.refundDetails?.id,
            paymentMethods: getRefundDetails?.data?.refundDetails?.paymentMethods,
            totalAmount: parseFloat(getRefundDetails?.data?.refundDetails?.totalAmount),
            status: 0
        }
        const response = await refundRequest.mutateAsync(payload)
        if (response.status) {
            toast.success('Refund request added')
            await getRefundDetails?.refetch()
        } else {
            toast.error(response?.description)
        }
    }
    console.log("==getRefundDetails=======", getRefundDetails?.data)
    return (
        <div id="sixthTab" className="tabcontent">
            <div className="editSec">

            </div>
            <h3>{t("REfundRequest")}</h3>
            <div className="tabcontent_form_section">
                <ListGroup variant="flush">
                    <ListGroup.Item> <i class="fa-solid fa-star" style={{ color: "#ddaf43" }}></i> Package Name :{" "}
                        <span className='refund_details'><strong>{getRefundDetails?.data?.packageInfo?.name}</strong></span></ListGroup.Item>
                    <ListGroup.Item> <i class="fa-solid fa-star" style={{ color: "#ddaf43" }}></i> Total Amount :{" "}
                        <span className='refund_details'><strong> {currency?.symbolLeft}{" "}
                            {CurrencyConverter(
                                getRefundDetails?.data?.refundDetails?.totalAmount,
                                conversionFactor
                            )}</strong></span></ListGroup.Item>
                    {
                        getRefundDetails?.data?.paymentDetails?.map((item) => (
                            <ListGroup.Item> <i class="fa-solid fa-star" style={{ color: "#ddaf43" }}></i>  Payment Method: {" "}
                                <span className='refund_details'>
                                    {/* <strong>  {CurrencyConverter(
                                        item.amount,
                                        conversionFactor
                                    )}</strong> */}
                                    {item.payment_method_name}

                                </span>
                            </ListGroup.Item>

                        ))
                    }
                </ListGroup>
                <Button className='mt-4' style={{ marginLeft: '23px' }}
                    onClick={refundRequestHandler}
                    disabled={refundRequest?.isLoading || (getRefundDetails?.data?.refundRequestDetails?.status === 0 || getRefundDetails?.data?.refundRequestDetails?.status === 1)}>
                    {
                        getRefundDetails?.data?.refundRequestDetails?.status === 0 ?
                            'Requested'
                            : getRefundDetails?.data?.refundRequestDetails?.status === 1 ?
                                'Approved'
                                : 'Request Refund'

                    }
                </Button>
            </div>

        </div>
    )
}

export default RefundRequest